import { assert, IGNORED, Test } from "oc-e2e-testrunner";
import {
  assertWarnungen,
  createElement,
  createMauer,
  getInspiredArrangement,
  logPartBoxes,
  resetArrangement,
} from "./utils";
import { v2, v3 } from "oc-threejs/short3";
import * as Commons from "oc-commons/Commons";

export default {
  name: "TestSaveAndLoad",
};

function assertEqualNumberOfElementsAfterToFromJson() {
  const oldParts = new Set(APP.arrangement.getElemente());
  const t = APP.getStageAsConfiguration();
  resetArrangement(true);
  APP.setStageFromConfiguration(t);
  const agtNew = APP.arrangement;
  agtNew.update3d();
  agtNew.update3d();
  const newParts = new Set(agtNew.getElemente());
  assert.equals(oldParts.size, newParts.size, "Expect Number of Elements to match");
}

const getInspirationTest = (inspKey) => async () => {
  const agt = getInspiredArrangement(inspKey);
  const s = agt.segmente[0];
  agt.update3d();
  createElement(s, {
    size: v2(0.98, 1.8),
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
  });
  agt.update3d();
  s.empties[0].setKonfigurierbareBreite(12);
  agt.update3d();
  [...s.empties, ...s.parts.filter((p) => p.isEmpty)].forEach((empty, i) => {
    empty.fillWithElements(agt.createDefaultElement(), {
      allowMassElement: i == 0,
      allowToGrowToMaximum: true,
    });
    agt.update3d();
  });
  APP.arrangement.setSelectedObjects(s.empties[0]);
  await APP.arrangement.removeSelectedObjects();
  agt.update3d();
  s.empties[0].fillWithElements(agt.createDefaultElement(), {
    allowMassElement: true,
    allowToGrowToMaximum: true,
  });
  agt.update3d();
  assertEqualNumberOfElementsAfterToFromJson();
};

export const testSystemHolz: Test = getInspirationTest("Inspiration SYSTEM HOLZ Thermokiefer");
export const testSystemWpcPlatinium: Test = getInspirationTest(
  "Inspiration SYSTEM WPC PLATINUM Anthrazit"
);
export const testSystemRhombus: Test = getInspirationTest("Inspiration SYSTEM RHOMBUS Lärche");
export const testSystemAlu: Test = getInspirationTest("Inspiration SYSTEM ALU Plus Weiß");
export const testSystemAluXL: Test = getInspirationTest("Inspiration SYSTEM ALU XL Plus Bambus");
export const testSystemWpc: Test = getInspirationTest("Inspiration SYSTEM WPC CLASSIC Grau");
export const testSystemWpcXL: Test = getInspirationTest("Inspiration SYSTEM WPC XL Sand");
export const testSystemKeramik: Test = getInspirationTest("Inspiration SYSTEM KERAMIK Zement");
export const testSystemGlasBetweenWalls: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM GLAS Matt");
  const lücken = [1.51, 1.49, 1.02];
  createMauer({ position: v3(-9.5, 0, 10), size: v3(0.5, 2, 1), drehung: Math.PI / 2 });
  let left = -9;
  for (const width of lücken) {
    left += width;
    createMauer({ position: v3(left + 0.5, 0, 10), size: v3(0.5, 2, 1), drehung: Math.PI / 2 });
    left += 1;
  }
  createMauer({ position: v3(9.5, 0, 10), size: v3(0.5, 2, 1), drehung: Math.PI / 2 });
  agt.update3d();
  agt.segmente
    .filter((a) => a.breite < 10)
    .forEach((beetweenWalls) =>
      beetweenWalls.empties[0].fillWithElements(agt.createDefaultElement(), {
        allowMassElement: true,
        allowToGrowToMaximum: true,
      })
    );
  agt.update3d();
  const tür = _.minBy(agt.segmente, (s) => s.breite - lücken.at(-1)).parts[0];
  APP.arrangement.setSelectedObjects(tür);
  agt.changeSelectedZaunElemente({
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
    füllungAuswahlwert: APP.richMetadata.findAuswahlwert("SYSTEM Rhombus Anthrazit"),
  });
  agt.update3d();
  assertEqualNumberOfElementsAfterToFromJson();
};

export const testLoadRealConfiguration1: Test = async () => {
  // Inspiration SYSTEM NEO WPC PLATINUM Lärche hat Metadatenänderungen
  resetArrangement(true);
  const agt = APP.arrangement;
  const configuration = {
    inspiration: "Inspiration SYSTEM NEO WPC PLATINUM Lärche",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    grundriss: {
      ecken: [
        {
          id: 2,
          punkt: {
            x: -13,
            y: -10,
          },
        },
        {
          id: 3,
          punkt: {
            x: -4,
            y: -10,
          },
        },
        {
          id: 4,
          punkt: {
            x: -4,
            y: -6.08,
          },
        },
        {
          id: 5,
          punkt: {
            x: 2,
            y: -10,
          },
        },
      ],
      kanten: [
        {
          ecken: [2, 3],
        },
        {
          ecken: [3, 4],
        },
        {
          ecken: [3, 5],
        },
      ],
    },
    segmente: [
      {
        breite: 9,
        partsAndPfosten: [
          {
            type: "Pfosten",
            x0: 3.105,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 3.155,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 10,
            profilPositionKorrigiert: 10,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 0,
            isStandardMass: true,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
          {
            type: "Pfosten",
            x0: 4.915,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.605,
            höhe: 1.8,
            snap: 1,
            isBreiteKonfigurierbar: false,
            x0: 4.975,
            füllungAuswahlwert: "Designgitter Trigon Weiß",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Designgitter_60x180",
            profilPosition: 2,
            profilPositionKorrigiert: 2,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 1,
            isStandardMass: true,
            detailSerie: "SYSTEM Designgitter",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
          },
          {
            position: {
              x: 5.585,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0.008,
                z: -0.02,
              },
              max: {
                x: 0.015,
                y: 1.94,
                z: 0.02,
              },
            },
            size: {
              x: 0.03,
              y: 1.932,
              z: 0.04,
            },
            type: "UMProfil",
            meta: "4606 SYSTEM  U-Klemmprofil Weiß 192 cm",
          },
          {
            type: "Pfosten",
            x0: 5.6,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwert: "Elementhalter Weiß",
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Metalltorpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
            pfostenAuswahlwert: "Torpfosten Aufschrauben Weiß",
          },
          {
            type: "Element",
            breite: 0.98,
            höhe: 1.8,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 5.693,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_weiß",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            rahmenAuswahlwert: "Tor_Rahmen_Weiss",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Basisprofile_Sondertore_NEO_WPC_15cm",
            profilAuswahlwert: "SYSTEM NEO WPC PLATINUM Anthrazit",
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Einzeltor",
            massAuswahlwert: "Einzeltor_Easy",
            profilPosition: 2,
            profilPositionKorrigiert: 2,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: true,
            elementNr: 2,
            isStandardMass: true,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasstor: false,
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: true,
            isEAntrieb: false,
            key: "2966 SYSTEM NEO WPC Platinum Sondertor einseitig_15",
            lichteWeite: 1.005,
            einsteckschlossAuswahlwert: "Einsteckschloss_inklusive",
            beschlagsatzAuswahlwert: "Beschlagsatz_inklusive",
            hideRahmen: false,
            showProfilausrichtung: true,
            showAdapterleiste: false,
            hasAnschlagprofil: false,
            bestelllisteArtikel: ["609"],
            artikelID: "2966_wpc",
            füllungName: "Füllung",
            ausrichtungCode: "eirb",
            profilAnzahl: 1,
            pdf: {},
          },
          {
            type: "Pfosten",
            x0: 6.685,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwert: "Elementhalter Weiß",
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Metalltorpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
            pfostenAuswahlwert: "Torpfosten Aufschrauben Weiß",
          },
          {
            position: {
              x: 6.78,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0.008,
                z: -0.02,
              },
              max: {
                x: 0.015,
                y: 1.94,
                z: 0.02,
              },
            },
            size: {
              x: 0.03,
              y: 1.932,
              z: 0.04,
            },
            type: "UMProfil",
            meta: "4606 SYSTEM  U-Klemmprofil Weiß 192 cm",
          },
          {
            type: "Element",
            breite: 0.605,
            höhe: 1.8,
            snap: 1,
            isBreiteKonfigurierbar: false,
            x0: 6.785,
            füllungAuswahlwert: "Designgitter Trigon Weiß",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Designgitter_60x180",
            profilPosition: 2,
            profilPositionKorrigiert: 2,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 3,
            isStandardMass: true,
            detailSerie: "SYSTEM Designgitter",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
          },
          {
            type: "Pfosten",
            x0: 7.38,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.555,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 7.43,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 10,
            profilPositionKorrigiert: 10,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 4,
            isStandardMass: false,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
      {
        breite: 3.92,
        partsAndPfosten: [
          {
            position: {
              x: 0.05,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0,
                z: -0.02,
              },
              max: {
                x: 0.015,
                y: 1.93,
                z: 0.02,
              },
            },
            size: {
              x: 0.03,
              y: 1.93,
              z: 0.04,
            },
            type: "UMProfil",
            meta: "4606 SYSTEM  U-Klemmprofil Weiß 192 cm",
          },
          {
            type: "Element",
            breite: 0.85,
            höhe: 1.845,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 0.045,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "90x180_Easy",
            profilPosition: 10,
            profilPositionKorrigiert: 10,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 5,
            isStandardMass: false,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
          {
            type: "Pfosten",
            x0: 0.875,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.91,
            höhe: 1.84,
            snap: -1,
            isBreiteKonfigurierbar: false,
            x0: 0.925,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Anschluss",
            massAuswahlwert: "Anschluss_Easy",
            profilPosition: 2,
            profilPositionKorrigiert: 2,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 6,
            isStandardMass: true,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
          },
          {
            type: "Pfosten",
            x0: 1.815,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.605,
            höhe: 0.9,
            snap: -1,
            isBreiteKonfigurierbar: false,
            x0: 1.875,
            füllungAuswahlwert: "Designgitter Trigon Weiß",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Designgitter_60x90",
            profilPosition: 2,
            profilPositionKorrigiert: 2,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 7,
            isStandardMass: true,
            detailSerie: "SYSTEM Designgitter",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
          },
          {
            type: "Pfosten",
            x0: 2.47,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.25,
            höhe: 0.945,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 2.52,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x90_Easy",
            profilPosition: 4,
            profilPositionKorrigiert: 4,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 8,
            isStandardMass: false,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
          {
            type: "Pfosten",
            x0: 3.75,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
      {
        breite: 6,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.845,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 0.015,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Trigon Weiss/flach",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_weiss",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 10,
            profilPositionKorrigiert: 10,
            profilPositionIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 9,
            isStandardMass: true,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
          {
            type: "Pfosten",
            x0: 1.775,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.845,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 1.825,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Trigon Weiss/flach",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_weiss",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 10,
            profilPositionKorrigiert: 10,
            profilPositionIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 10,
            isStandardMass: true,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
          {
            type: "Pfosten",
            x0: 3.585,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.845,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 3.635,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Trigon Weiss/flach",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_weiss",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 10,
            profilPositionKorrigiert: 10,
            profilPositionIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 11,
            isStandardMass: true,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
          {
            type: "Pfosten",
            x0: 5.395,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
    ],
    ecken: [
      {
        position: {
          x: -13,
          y: 0,
          z: -10,
        },
      },
      {
        position: {
          x: -4,
          y: 0,
          z: -10,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: -4,
            y: 0,
            z: -10,
          },
          pfostenfarbeAuswahlwert: "Weiß",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Steckpfosten",
          pfostenartAuswahlwertIndividualisiert: false,
          montageadapterAuswahlwert: "Montageadapter_ohne",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: -4,
          y: 0,
          z: -6.08,
        },
      },
      {
        position: {
          x: 2,
          y: 0,
          z: -10,
        },
      },
    ],
    aufbauten: [],
    lichtleistenSplitter: 0,
    lichtleistenZubehör: {
      "Edelstahl-Blende_Lichtleiste_Steckzaun": 0,
      "3834 SYSTEM Licht Smart Control Set": 0,
      "3836 SYSTEM Licht Fernbedienung": 0,
      "3835 SYSTEM Licht Bewegungsmelder": 0,
      "3837 SYSTEM Licht Steuerungsadapter": 0,
      "3838 SYSTEM Licht Kabel Zusatz-Steuerungsadapter": 0,
    },
    pfostenartAuswahlwert: "Steckpfosten",
    pfostenfarbeAuswahlwert: "Weiß",
    bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
    elementhalterAuswahlwert: "Elementhalter Weiß",
    verteilungsstrategieAuswahlwert: "LeerraumLinks",
    verbundankerAuswahlwert: "Verbundanker-Set_mit",
    bestellliste: [
      {
        ArtikelID: "3730",
        Anzahl: 6,
        AnzahlEditiert: false,
        ElementIndizes: [0, 4, 5, 9, 10, 11],
      },
      {
        ArtikelID: "3731",
        Anzahl: 1,
        AnzahlEditiert: false,
        ElementIndizes: [6],
      },
      {
        ArtikelID: "3755",
        Anzahl: 2,
        AnzahlEditiert: false,
        ElementIndizes: [1, 3],
      },
      {
        ArtikelID: "3757",
        Anzahl: 1,
        AnzahlEditiert: false,
        ElementIndizes: [7],
      },
      {
        ArtikelID: "3990",
        Anzahl: 3,
        AnzahlEditiert: false,
        ElementIndizes: [9, 10, 11],
      },
      {
        ArtikelID: "3992",
        Anzahl: 3,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
      {
        ArtikelID: "3936",
        Anzahl: 8,
        AnzahlEditiert: false,
        ElementIndizes: [0, 4, 5, 6, 8, 9, 10, 11],
      },
      {
        ArtikelID: "3944",
        Anzahl: 8,
        AnzahlEditiert: false,
        ElementIndizes: [0, 4, 5, 6, 8, 9, 10, 11],
      },
      {
        ArtikelID: "4830",
        Anzahl: 3,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
      {
        ArtikelID: "4831",
        Anzahl: 8,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
      {
        ArtikelID: "2966_wpc",
        Anzahl: 1,
        AnzahlEditiert: false,
        ElementIndizes: [2],
      },
      {
        ArtikelID: "609",
        Anzahl: 1,
        AnzahlEditiert: false,
        ElementIndizes: [2],
      },
      {
        ArtikelID: "4606",
        Anzahl: 3,
        AnzahlEditiert: false,
        ElementIndizes: [1, 3, 5],
      },
      {
        ArtikelID: "4652",
        Anzahl: 1,
        AnzahlEditiert: false,
        ElementIndizes: [2],
      },
      {
        ArtikelID: "2550",
        Anzahl: 1,
        AnzahlEditiert: false,
        ElementIndizes: [2],
      },
      {
        ArtikelID: "1398",
        Anzahl: 2,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
      {
        ArtikelID: "1272",
        Anzahl: 7,
        AnzahlEditiert: false,
        ElementIndizes: [2],
      },
    ],
    customAnzahlen: {},
    gesamtpreis: 5867.9,
    baugruppen: [
      [
        {
          ArtikelID: "3730",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "3936",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "3944",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
      [
        {
          ArtikelID: "3730",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "3936",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "3944",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "3730",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "4606",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "3936",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "3944",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "3730",
          Anzahl: 3,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "3990",
          Anzahl: 3,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "3992",
          Anzahl: 3,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "3936",
          Anzahl: 3,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "3944",
          Anzahl: 3,
          MassOrBauseitsTag: "",
        },
      ],
      [
        {
          ArtikelID: "3731",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "3936",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "3944",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
      [
        {
          ArtikelID: "3755",
          Anzahl: 2,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "4606",
          Anzahl: 2,
          MassOrBauseitsTag: "",
        },
      ],
      [
        {
          ArtikelID: "3757",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
      [
        {
          ArtikelID: "3733",
          Anzahl: 6,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "3936",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "3944",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "4831",
          Anzahl: 8,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1272",
          Anzahl: 8,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1398",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
      [
        {
          ArtikelID: "4830",
          Anzahl: 3,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1272",
          Anzahl: 3,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1398",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
      [
        {
          ArtikelID: "2966_wpc",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "609",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "4652",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1272",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "2550",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
    ],
    warnungen: [],
    warnungenMitWichtigkeit: [],
    montageanleitungenArtikelIDs: ["3755", "2966_wpc"],
    inspirationsBilder: ["/Auswahlwert/system-neo-wpc-platinum-laerche-52.jpg"],
    pageName: "Zauneditor",
    userDefinedArticles: [],
    hinweistexte: [],
    zauneditorVisited: true,
  };
  agt.arrangement.fromJSON(configuration);
  agt.update3d();
  const actualJson = agt.arrangement.toJSON();
  assert.deepEqualsStringified(
    configuration,
    actualJson,
    "Serialisiertes JSON vorher/nachher ist gleich",
    0.001
  );
};

export const testLoadRealConfiguration3: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;

  const configuration = {
    inspiration: "Inspiration SYSTEM ALU Plus Weiß",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    form: {
      type: "Strecke",
      seitenLaengen: [4.35, 3],
      zaunSeitenFüllen: [null],
    },
    segmente: [
      {
        formSeitenIndex: 0,
        breite: 4.35,
        partsAndPfosten: [
          {
            type: "Pfosten",
            x0: 0.05,
            pfostenfarbeAuswahlwert: "Silber",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.91,
            höhe: 1.84,
            snap: 1,
            isBreiteKonfigurierbar: false,
            x0: 0.11,
            füllungAuswahlwert: "SYSTEM WPC XL Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Anschluss",
            massAuswahlwert: "Anschluss_Easy",
            profilPosition: null,
            showProfil: false,
            anschlussAufRechts: true,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: true,
            detailSerie: "SYSTEM WPC XL",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 1,
            pfostenfarbeAuswahlwert: "Silber",
            pfostenfarbeAuswahlwertIndividualisert: true,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.61,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 1.05,
            füllungAuswahlwert: "SYSTEM WPC XL Sand",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Mattglas/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 5,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC XL",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 2.64,
            pfostenfarbeAuswahlwert: "Silber",
            pfostenfarbeAuswahlwertIndividualisert: true,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.61,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 2.69,
            füllungAuswahlwert: "SYSTEM WPC XL Sand",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Mattglas/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 5,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC XL",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 4.28,
            pfostenfarbeAuswahlwert: "Silber",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
        ],
      },
    ],
    ecken: [
      {
        position: {
          x: -2.175,
          y: 0,
          z: 0,
        },
      },
      {
        position: {
          x: 2.175,
          y: 0,
          z: 0,
        },
      },
    ],
    aufbauten: [
      {
        Key: "281b64o79ph0",
        aufbauMeta: "Terrasse",
        position: {
          x: -0.012610059980782766,
          y: 0,
          z: -1.1216087556395913,
        },
        size: {
          x: 4.570166659402757,
          y: 0.1,
          z: 2.0020645271411643,
        },
        drehung: 0,
      },
      {
        Key: "bts564o7a0h0",
        aufbauMeta: "Haus",
        position: {
          x: 4.076422096627582,
          y: 0,
          z: 0.43923163940278803,
        },
        size: {
          x: 3.5953353684800224,
          y: 4,
          z: 5.14412308598956,
        },
        drehung: 0,
      },
    ],
    pfostenartAuswahlwert: "Klemmpfosten",
    pfostenfarbeAuswahlwert: "Silber",
    bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
    bestellliste: [],
    gesamtpreis: 1183.3,
    baugruppen: [],
    warnungen: [],
    montageanleitungen: [],
    pageName: "Zauneditor",
  };
  agt.arrangement.fromJSON(configuration);
  agt.update3d();
  assert.equals(3, agt.getElemente().length);
  assert.deepEquals(
    [
      {
        type: "2247 SYSTEM Steckpfosten Silber Erdverbau  240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.930,0.033))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(0.085,1.800,0.050))",
      },
      {
        type: "2312 SYSTEM Klemmpfosten Silber 105 cm | einbetoniert",
        box: "((-0.040,0.000,-0.045),(0.040,1.045,0.045))",
      },
      {
        type: "3741 SYSTEM  WPC XL Sand/Anthrazit Zaun-Anschluss-Set 91 x 184 auf 94 cm",
        box: "((0.000,0.000,-0.010),(0.910,1.840,0.010))",
      },
      {
        type: "2247 SYSTEM Steckpfosten Silber Erdverbau  240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.930,0.033))",
      },
      {
        type: "3740 SYSTEM  WPC XL Sand/Anthrazit Zaunfeld-Set 178 x 184 cm",
        box: "((0.000,0.000,-0.010),(1.610,1.845,0.010))",
      },
      {
        type: "2247 SYSTEM Steckpfosten Silber Erdverbau  240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.930,0.033))",
      },
      {
        type: "3740 SYSTEM  WPC XL Sand/Anthrazit Zaunfeld-Set 178 x 184 cm",
        box: "((0.000,0.000,-0.010),(1.610,1.845,0.010))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(0.085,1.800,0.050))",
      },
      {
        type: "Terrasse",
        box: "((-2.285,0.000,-1.001),(2.285,0.100,1.001))",
      },
      {
        type: "Haus",
        box: "((-1.798,-1.000,-2.572),(1.798,4.000,2.572))",
      },
    ],
    logPartBoxes([...agt.getPartsAndPfosten(), ...agt.getEmpties(), ...agt.aufbauten])
  );
};

export const testLoadRealConfiguration4: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;

  const configuration = {
    inspiration: "Inspiration SYSTEM RHOMBUS Weiß",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    form: {
      type: "LForm",
      seitenLaengen: [1, 1.5, 2.7, 2.4],
      zaunSeitenFüllen: [null, null, null, null, null, null],
    },
    segmente: [
      {
        formSeitenIndex: 0,
        breite: 3.82,
        partsAndPfosten: [],
      },
      {
        formSeitenIndex: 1,
        breite: 0.92,
        partsAndPfosten: [],
      },
      {
        formSeitenIndex: 2,
        breite: 1.5,
        partsAndPfosten: [
          {
            type: "Pfosten",
            x0: 0.04,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
            elementID: 2,
          },
          {
            type: "Element",
            breite: 1.36,
            höhe: 1.8,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.095,
            füllungAuswahlwert: "SYSTEM Rhombus Weiß",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile_15cm_Zaunfeld_Rhombus",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 26,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS",
            anMauer: "AnMauer_nein",
            elementID: 2,
          },
          {
            position: {
              x: 1.445,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0.008138023117171711,
                z: -0.02000000001862645,
              },
              max: {
                x: 0.015,
                y: 1.9400000000000002,
                z: 0.02000000001862645,
              },
            },
            size: {
              x: 0.03,
              y: 1.9318619768828285,
              z: 0.0400000000372529,
            },
            type: "UMProfil",
            meta: "4606 SYSTEM  U-Klemmprofil Weiß 192 cm",
          },
        ],
      },
      {
        formSeitenIndex: 3,
        breite: 2.7,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.01,
            höhe: 1.8,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 0.0525,
            füllungAuswahlwert: "SYSTEM Rhombus Weiß",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Klinke_weiß",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            rahmenAuswahlwert: "Tor_Rahmen_Weiss",
            öffnungAuswahlwert: "Öffnung_nach_außen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Basisprofile_Rhombus_5_Tor",
            profilAuswahlwert: "SYSTEM Rhombus Bambus",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Einzeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Einzeltor",
            massAuswahlwert: "Einzeltor_Easy",
            profilPosition: 25,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: true,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS",
            anMauer: "AnMauer_nein",
            elementID: 3,
          },
          {
            type: "Pfosten",
            x0: 1.075,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
            pfostenAuswahlwert: "Torpfosten Einbetonieren Weiß",
          },
          {
            position: {
              x: 1.17,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0.008138023117171711,
                z: -0.02000000001862645,
              },
              max: {
                x: 0.015,
                y: 1.9400000000000002,
                z: 0.02000000001862645,
              },
            },
            size: {
              x: 0.03,
              y: 1.9318619768828285,
              z: 0.0400000000372529,
            },
            type: "UMProfil",
            meta: "4606 SYSTEM  U-Klemmprofil Weiß 192 cm",
          },
          {
            type: "Element",
            breite: 1.53,
            höhe: 1.8,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 1.16,
            füllungAuswahlwert: "SYSTEM Rhombus Weiß",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile_15cm_Zaunfeld_Rhombus",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 26,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS",
            anMauer: "AnMauer_nein",
            elementID: 3,
          },
        ],
      },
      {
        formSeitenIndex: 4,
        breite: 2.32,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.8,
            höhe: 1.8,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 0.015,
            füllungAuswahlwert: "SYSTEM Rhombus Weiß",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile_15cm_Zaunfeld_Rhombus",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 26,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: true,
            detailSerie: "SYSTEM RHOMBUS",
            anMauer: "AnMauer_nein",
            elementID: 4,
          },
          {
            type: "Pfosten",
            x0: 1.79,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.46,
            höhe: 1.8,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 1.845,
            füllungAuswahlwert: "SYSTEM Rhombus Weiß",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile_15cm_Zaunfeld_Rhombus",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "60x180_Easy",
            profilPosition: 26,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS",
            anMauer: "AnMauer_nein",
            elementID: 4,
          },
        ],
      },
      {
        formSeitenIndex: 5,
        breite: 3.62,
        partsAndPfosten: [],
      },
    ],
    ecken: [
      {
        position: {
          x: -1.81,
          y: 0,
          z: -1.91,
        },
      },
      {
        position: {
          x: -1.81,
          y: 0,
          z: 1.91,
        },
      },
      {
        position: {
          x: -0.8900000000000001,
          y: 0,
          z: 1.91,
        },
      },
      {
        position: {
          x: -0.8900000000000001,
          y: 0,
          z: 0.41,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: -0.8900000000000001,
            y: 0,
            z: 0.41,
          },
          pfostenfarbeAuswahlwert: "Weiß",
          pfostenfarbeAuswahlwertIndividualisert: false,
          bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
          bodenbefestigungAuswahlwertIndividualisert: false,
          elementhalterAuswahlwertIndividualisert: false,
          pfostenartAuswahlwert: "Klemmpfosten",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          ausgleichGefälle: false,
          pfostenAuswahlwert: "Torpfosten Einbetonieren Weiß",
        },
      },
      {
        position: {
          x: 1.81,
          y: 0,
          z: 0.41,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: 1.81,
            y: 0,
            z: 0.41,
          },
          pfostenfarbeAuswahlwert: "Weiß",
          pfostenfarbeAuswahlwertIndividualisert: false,
          bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
          bodenbefestigungAuswahlwertIndividualisert: false,
          elementhalterAuswahlwertIndividualisert: false,
          pfostenartAuswahlwert: "Klemmpfosten",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: 1.81,
          y: 0,
          z: -1.91,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: 1.81,
            y: 0,
            z: -1.91,
          },
          pfostenfarbeAuswahlwert: "Weiß",
          pfostenfarbeAuswahlwertIndividualisert: false,
          bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
          bodenbefestigungAuswahlwertIndividualisert: false,
          elementhalterAuswahlwertIndividualisert: false,
          pfostenartAuswahlwert: "Klemmpfosten",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
    ],
    aufbauten: [
      {
        Key: "1jov62e5urua",
        aufbauMeta: "Beet",
        position: {
          x: 0.002246944611567016,
          y: 0,
          z: -0.7647274171129661,
        },
        size: {
          x: 3.614162002962562,
          y: 0.02,
          z: 2.334015913308274,
        },
        drehung: 0.004404693920724483,
      },
      {
        Key: "331662e5v87h",
        aufbauMeta: "Beet",
        position: {
          x: -1.3590478924940037,
          y: 0,
          z: 0.709426425083691,
        },
        size: {
          x: 0.9053104972450285,
          y: 0.02,
          z: 2.4047166626231995,
        },
        drehung: 0,
      },
    ],
    pfostenartAuswahlwert: "Klemmpfosten",
    pfostenfarbeAuswahlwert: "Weiß",
    bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
    pageName: "Zauneditor",
  };
  agt.arrangement.fromJSON(configuration);
  agt.update3d();
  assert.equals(5, agt.getElemente().length);
  let segmentZuordnung = agt.getElemente().map((e) => ({
    segmentIndex: e.segment.segmentIndex,
    segmentBreite: e.segment.breite,
    elementID: e.elementID,
  }));
  segmentZuordnung = _.sortBy(segmentZuordnung, (x) => x.segmentBreite);
  assert.deepEquals(
    [
      {
        segmentIndex: 1,
        segmentBreite: 1.5,
        elementID: 2,
      },
      {
        segmentIndex: 4,
        segmentBreite: 2.4,
        elementID: 4,
      },
      {
        segmentIndex: 4,
        segmentBreite: 2.4,
        elementID: 4,
      },
      {
        segmentIndex: 2,
        segmentBreite: 2.7,
        elementID: 3,
      },
      {
        segmentIndex: 2,
        segmentBreite: 2.7,
        elementID: 3,
      },
    ],
    segmentZuordnung
  );
  assert.deepEquals(
    [
      {
        type: "E1289 Torpfosten einbetonieren 180 weiß Aufhängeseite",
        box: "((-0.040,-0.600,-0.040),(0.040,1.940,0.040))",
      },
      {
        type: "4604 SYSTEM Eck-Klemmpfosten Weiß 192 cm | einbetoniert",
        box: "((-0.038,0.000,-0.038),(0.038,1.915,0.038))",
      },
      {
        type: "4601 SYSTEM Klemmpfosten Weiß 192 cm | einbetoniert",
        box: "((-0.040,0.000,-0.045),(0.040,1.915,0.045))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(1.000,1.800,0.050))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(0.040,1.800,0.050))",
      },
      {
        type: "4601 SYSTEM Klemmpfosten Weiß 192 cm | einbetoniert",
        box: "((-0.040,0.000,-0.045),(0.040,1.915,0.045))",
      },
      {
        type: "2951 SYSTEM RHOMBUS Weiß 180 x 180 cm",
        box: "((0.000,0.000,-0.010),(1.360,1.800,0.010))",
      },
      {
        type: "4606 SYSTEM  U-Klemmprofil Weiß 192 cm",
        box: "((-0.015,0.008,-0.020),(0.015,1.940,0.020))",
      },
      {
        type: "2557 SYSTEM RHOMBUS Mass Einzeltor",
        box: "((0.000,0.000,-0.011),(1.010,1.800,0.011))",
      },
      {
        type: "E1290 Torpfosten einbetonieren 180 weiß Schlossseite",
        box: "((-0.040,-0.600,-0.040),(0.040,1.940,0.040))",
      },
      {
        type: "4606 SYSTEM  U-Klemmprofil Weiß 192 cm",
        box: "((-0.015,0.008,-0.020),(0.015,1.940,0.020))",
      },
      {
        type: "2951 SYSTEM RHOMBUS Weiß 180 x 180 cm",
        box: "((0.000,0.000,-0.010),(1.530,1.800,0.010))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(3.900,1.800,0.050))",
      },
      {
        type: "2951 SYSTEM RHOMBUS Weiß 180 x 180 cm",
        box: "((0.000,0.000,-0.010),(1.800,1.800,0.010))",
      },
      {
        type: "4601 SYSTEM Klemmpfosten Weiß 192 cm | einbetoniert",
        box: "((-0.040,0.000,-0.045),(0.040,1.915,0.045))",
      },
      {
        type: "2952 SYSTEM RHOMBUS Weiß 60 x 180 cm",
        box: "((0.000,0.000,-0.010),(0.460,1.800,0.010))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(3.700,1.800,0.050))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(1.000,1.800,0.050))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(0.040,1.800,0.050))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(3.900,1.800,0.050))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(3.700,1.800,0.050))",
      },
      {
        type: "Beet",
        box: "((-1.807,0.000,-1.167),(1.807,0.020,1.167))",
      },
      {
        type: "Beet",
        box: "((-0.453,0.000,-1.202),(0.453,0.020,1.202))",
      },
    ],
    logPartBoxes([...agt.getPartsAndPfosten(), ...agt.getEmpties(), ...agt.aufbauten])
  );
};

export const testLoadRealConfiguration5: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;

  const configuration = {
    inspiration: "Inspiration SYSTEM RHOMBUS Weiß",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    form: {
      type: "LForm",
      seitenLaengen: [1, 1.5, 2.7, 2.4],
      zaunSeitenFüllen: [null, null, null, null, null, null],
    },
    segmente: _.range(0, 6).map((i) => ({
      breite: 1,
      partsAndPfosten: [],
    })),
    ecken: [],
    aufbauten: [],
    pfostenartAuswahlwert: "Klemmpfosten",
    pfostenfarbeAuswahlwert: "Weiß",
    bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
    pageName: "Zauneditor",
  };
  const elementJson = {
    type: "Element",
    breite: 0.5,
    höhe: 1.8,
    snap: 1,
    isBreiteKonfigurierbar: true,
    x0: 0.095,
    füllungAuswahlwert: "SYSTEM Rhombus Weiß",
    füllungAuswahlwertIndividualisiert: false,
    gehflügelAuswahlwert: "Gehflügel_links",
    drückerAuswahlwert: "Drücker_Knauf_edelstahl",
    profilzylinderAuswahlwert: "Profilzylinder_mit",
    öffnungAuswahlwert: "Öffnung_nach_innen",
    anschlagAuswahlwert: "Anschlag_links",
    schieberichtungAuswahlwert: "Schieberichtung_links",
    schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
    füllungsseiteAuswahlwert: "Füllungsseite_B",
    anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
    abschlussleisteAuswahlwertIndividualisiert: false,
    profilKategorieAuswahlwert: "Dekorprofile_15cm_Zaunfeld_Rhombus",
    profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
    profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
    zubehörAnzahl: {
      Handsender: 0,
      "Handsender Design": 0,
      Schlüsselschalter: 0,
      "Funk-Codeschloss": 0,
      "Bluetooth Schalter": 0,
      "Connect Gateway": 0,
      Lichtschranke: 0,
      "Techniker Key": 0,
    },
    toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
    torschließerAuswahlwert: "Torschließer_ohne",
    form: "Rechteck",
    massAuswahlwert: "180x180_Easy",
    profilPosition: 26,
    profilPositionIndividualisiert: false,
    profilAuswahlwertIndividualisiert: false,
    showProfil: false,
    anschlussAufRechts: false,
    gehflügelbreite: 0,
    standflügelbreite: 0,
    torIstFertig: false,
    isStandardMass: false,
    detailSerie: "SYSTEM RHOMBUS",
    anMauer: "AnMauer_nein",
  };
  const c = Commons.cloneDeep(configuration);
  [0, 1, 2, 3, 4, 5].forEach((i) => {
    const e = Commons.cloneDeep(elementJson) as any;
    e.elementID = i;
    c.segmente[i].partsAndPfosten.push(e);
  });
  agt.arrangement.fromJSON(c);
  agt.update3d();
  let segmentZuordnung = agt.getElemente().map((e) => ({
    segmentIndex: e.segment.segmentIndex,
    segmentBreite: e.segment.breite,
    elementID: e.elementID,
  }));
  segmentZuordnung = _.sortBy(segmentZuordnung, (x) => x.segmentBreite);
  assert.deepEquals(
    [
      {
        segmentIndex: 0,
        segmentBreite: 1,
        elementID: 1,
      },
      {
        segmentIndex: 1,
        segmentBreite: 1.5,
        elementID: 2,
      },
      {
        segmentIndex: 4,
        segmentBreite: 2.4,
        elementID: 4,
      },
      {
        segmentIndex: 2,
        segmentBreite: 2.7,
        elementID: 3,
      },
      {
        segmentIndex: 5,
        segmentBreite: 3.7,
        elementID: 5,
      },
      {
        segmentIndex: 3,
        segmentBreite: 3.9,
        elementID: 0,
      },
    ],
    segmentZuordnung
  );
};

export const testLoadRealConfiguration6: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;

  const configuiration = {
    inspiration: "Inspiration SYSTEM WPC CLASSIC Sand",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    form: {
      type: "Rechteck",
      seitenLaengen: [22.75, 28],
      zaunSeitenFüllen: [null, null, null, null, null],
    },
    segmente: [
      {
        formSeitenIndex: 0,
        breite: 27.93,
        partsAndPfosten: [],
      },
      {
        formSeitenIndex: 1,
        breite: 22.68,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.02,
            höhe: 1.55,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.0525,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_anthrazit",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            rahmenAuswahlwert: "Tor_Rahmen_Anthrazit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_rechts",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_Tore",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Einzeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Einzeltor",
            massAuswahlwert: "Einzeltor_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: true,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 1.085,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: true,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
            pfostenAuswahlwert: "Torpfosten Einbetonieren Anthrazit",
          },
          {
            position: {
              x: 1.179999999999983,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0,
                z: -0.017502999864518642,
              },
              max: {
                x: 0.015,
                y: 1.6900000000000002,
                z: 0.017502999864518642,
              },
            },
            size: {
              x: 0.03,
              y: 1.6900000000000002,
              z: 0.035005999729037285,
            },
            type: "UMProfil",
            meta: "2415 SYSTEM U-Montageprofil 192 anthrazit",
          },
          {
            type: "Element",
            breite: 1.58,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 1.175,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 2.735,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 2.785,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 4.545,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 4.595,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 6.355,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 6.405,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 8.165,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 8.215,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 9.975,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 10.025,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 11.785,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 11.835,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 13.595,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 13.645,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 15.405,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 15.455,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 17.215,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 17.265,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 19.025,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 19.075,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 20.835,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 20.885,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
        ],
      },
      {
        formSeitenIndex: 2,
        breite: 19.5084,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.7384,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.015,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 1.7334,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: true,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.7445,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 1.7834,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 3.5079,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: true,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.7445,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 3.5579,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 5.2824,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: true,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.7445,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 5.3324,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 7.0569,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: true,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.7445,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 7.1069,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 8.8314,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: true,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.7445,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 8.8814,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 10.6059,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: true,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.7445,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 10.6559,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 12.3804,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: true,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.7445,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 12.4304,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 14.1549,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: true,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.7445,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 14.2049,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 15.9294,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: true,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.7445,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 15.9794,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 17.7039,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: true,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.7445,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 17.7539,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 8,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_rechts",
          },
          {
            type: "Pfosten",
            x0: 19.4784,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
        ],
      },
      {
        formSeitenIndex: 2,
        breite: 3.8249,
        partsAndPfosten: [
          {
            type: "Pfosten",
            x0: 0,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwertIndividualisert: true,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_mit",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.7445,
            höhe: 1.095,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 0.01,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x90_Easy",
            profilPosition: 6,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_links",
          },
          {
            type: "Pfosten",
            x0: 1.7345,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: true,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.095,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 1.7845,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x90_Easy",
            profilPosition: 6,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 3.5445,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: true,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
        ],
      },
      {
        formSeitenIndex: 3,
        breite: 22.68,
        partsAndPfosten: [],
      },
    ],
    ecken: [
      {
        position: {
          x: -11.339999999999996,
          y: 0,
          z: -13.965,
        },
      },
      {
        position: {
          x: -11.34,
          y: 0,
          z: 13.965,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: -11.34,
            y: 0,
            z: 13.965,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisert: false,
          bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
          bodenbefestigungAuswahlwertIndividualisert: false,
          elementhalterAuswahlwertIndividualisert: false,
          pfostenartAuswahlwert: "Steckpfosten",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          ankerInnen: false,
          ausgleichGefälle: false,
          pfostenAuswahlwert: "Torpfosten Einbetonieren Anthrazit",
        },
      },
      {
        position: {
          x: 11.34,
          y: 0,
          z: 13.965,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: 11.34,
            y: 0,
            z: 13.965,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisert: true,
          elementhalterAuswahlwertIndividualisert: false,
          pfostenartAuswahlwert: "Steckpfosten",
          montageadapterAuswahlwert: "Montageadapter_ohne",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: 11.34,
          y: 0,
          z: -5.543413595401084,
        },
      },
      {
        position: {
          x: 11.34,
          y: 0,
          z: -10.140125546187896,
        },
      },
      {
        position: {
          x: 11.34,
          y: 0,
          z: -13.965,
        },
      },
    ],
    aufbauten: [
      {
        Key: "cba263h6pcq4",
        aufbauMeta: "Garage",
        position: {
          x: 11.340843965098953,
          y: 0,
          z: -7.841769570794496,
        },
        size: {
          x: 4.1,
          y: 3,
          z: 4.59671195078673,
        },
        drehung: 0,
      },
    ],
    pfostenartAuswahlwert: "Steckpfosten",
    pfostenfarbeAuswahlwert: "Anthrazit",
    bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
    verbundankerAuswahlwert: "Verbundanker-Set_mit",
    pageName: "Zauneditor",
  };
  agt.arrangement.fromJSON(configuiration);
  agt.update3d();
  assert.deepEquals(
    [4],
    agt.getTore().map((e) => e.segment.segmentIndex)
  );
  assert.deepEquals(
    [0, 0, 11, 2, 13],
    agt.segmente.map((s) => s.parts.length)
  );
  assert.deepEquals(
    [
      {
        type: "2107 SYSTEM  Eck-Steckpfosten Anthrazit z. Aufschrauben 192 cm",
        box: "((-0.053,0.010,-0.053),(0.053,1.640,0.053))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(22.750,1.800,0.050))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(28.000,1.800,0.050))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.738,1.545,0.010))",
      },
      {
        type: "2144 SYSTEM Steckpfosten Anthrazit z.  Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.640,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.744,1.545,0.010))",
      },
      {
        type: "2144 SYSTEM Steckpfosten Anthrazit z.  Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.640,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.744,1.545,0.010))",
      },
      {
        type: "2144 SYSTEM Steckpfosten Anthrazit z.  Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.640,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.744,1.545,0.010))",
      },
      {
        type: "2144 SYSTEM Steckpfosten Anthrazit z.  Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.640,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.744,1.545,0.010))",
      },
      {
        type: "2144 SYSTEM Steckpfosten Anthrazit z.  Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.640,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.744,1.545,0.010))",
      },
      {
        type: "2144 SYSTEM Steckpfosten Anthrazit z.  Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.640,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.744,1.545,0.010))",
      },
      {
        type: "2144 SYSTEM Steckpfosten Anthrazit z.  Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.640,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.744,1.545,0.010))",
      },
      {
        type: "2144 SYSTEM Steckpfosten Anthrazit z.  Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.640,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.744,1.545,0.010))",
      },
      {
        type: "2144 SYSTEM Steckpfosten Anthrazit z.  Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.640,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.744,1.545,0.010))",
      },
      {
        type: "2144 SYSTEM Steckpfosten Anthrazit z.  Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.640,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.744,1.545,0.010))",
      },
      {
        type: "2415 SYSTEM U-Montageprofil 192 anthrazit",
        box: "((-0.015,0.000,-0.018),(0.015,1.595,0.018))",
      },
      {
        type: "2415 SYSTEM U-Montageprofil 192 anthrazit",
        box: "((-0.015,0.000,-0.018),(0.015,1.145,0.018))",
      },
      {
        type: "2234 SYSTEM WPC CLASSIC Sand/Silber Zaunfeld-Set 178 x 183 cm_vorgarten",
        box: "((0.000,0.000,-0.010),(1.744,1.095,0.010))",
      },
      {
        type: "2144 SYSTEM Steckpfosten Anthrazit z.  Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.190,0.033))",
      },
      {
        type: "2234 SYSTEM WPC CLASSIC Sand/Silber Zaunfeld-Set 178 x 183 cm_vorgarten",
        box: "((0.000,0.000,-0.010),(1.780,1.095,0.010))",
      },
      {
        type: "2144 SYSTEM Steckpfosten Anthrazit z.  Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.190,0.033))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(0.245,1.800,0.050))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(0.030,1.800,0.050))",
      },
      {
        type: "Torpfosten aufschrauben hhh anthrazit Aufhängeseite",
        box: "((-0.040,0.010,-0.040),(0.040,1.700,0.040))",
      },
      {
        type: "2499 SYSTEM WPC Classic Mass Einzeltor zweiseitig_15",
        box: "((0.000,0.000,-0.011),(1.020,1.550,0.011))",
      },
      {
        type: "Torpfosten einbetonieren hhh anthrazit Schlossseite",
        box: "((-0.040,-0.600,-0.040),(0.040,1.690,0.040))",
      },
      {
        type: "2415 SYSTEM U-Montageprofil 192 anthrazit",
        box: "((-0.015,0.000,-0.018),(0.015,1.690,0.018))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.580,1.545,0.010))",
      },
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.630,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.545,0.010))",
      },
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.630,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.545,0.010))",
      },
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.630,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.545,0.010))",
      },
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.630,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.545,0.010))",
      },
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.630,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.545,0.010))",
      },
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.630,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.545,0.010))",
      },
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.630,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.545,0.010))",
      },
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.630,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.545,0.010))",
      },
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.630,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.545,0.010))",
      },
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.630,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.545,0.010))",
      },
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.630,0.033))",
      },
      {
        type: "2175 SYSTEM WPC CLASSIC Sand/Anthrazit  Zaunfeld-Set 178 x 183 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.545,0.010))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(22.750,1.800,0.050))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(28.000,1.800,0.050))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(0.245,1.800,0.050))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(0.030,1.800,0.050))",
      },
      {
        type: "Garage",
        box: "((-2.050,-1.000,-2.298),(2.050,3.000,2.298))",
      },
    ],
    logPartBoxes([...agt.getPartsAndPfosten(), ...agt.getEmpties(), ...agt.aufbauten])
  );
};

export const testLoadRealConfiguration7: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;

  const configuiration = {
    inspiration: "Inspiration SYSTEM RHOMBUS Bambus",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    form: {
      type: "Strecke",
      seitenLaengen: [5.53, 3],
      zaunSeitenFüllen: [true],
    },
    segmente: [
      {
        formSeitenIndex: 0,
        breite: 5.53,
        partsAndPfosten: [
          {
            type: "Pfosten",
            x0: 0.04,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            ankerAuswahlwert: "Sturmanker Anthrazit",
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.76,
            höhe: 1.8,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.085,
            füllungAuswahlwert: "SYSTEM Rhombus Bambus",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile_15cm_Zaunfeld_Rhombus",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 26,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 1.82,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.8,
            höhe: 1.8,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 1.865,
            füllungAuswahlwert: "SYSTEM Rhombus Bambus",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile_15cm_Zaunfeld_Rhombus",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 26,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: true,
            detailSerie: "SYSTEM RHOMBUS",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 3.64,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.8,
            höhe: 1.8,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 3.685,
            füllungAuswahlwert: "SYSTEM Rhombus Bambus",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile_15cm_Zaunfeld_Rhombus",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Doppeltor_Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 26,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            isStandardMass: true,
            detailSerie: "SYSTEM RHOMBUS",
            anMauer: "AnMauer_nein",
          },
          {
            type: "Pfosten",
            x0: 5.46,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisert: false,
            ankerAuswahlwert: "Sturmanker Anthrazit",
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ausgleichGefälle: false,
          },
        ],
      },
    ],
    ecken: [
      {
        position: {
          x: -2.765,
          y: 0,
          z: 0,
        },
      },
      {
        position: {
          x: 2.765,
          y: 0,
          z: 0,
        },
      },
    ],
    aufbauten: [],
    pfostenartAuswahlwert: "Steckpfosten",
    pfostenfarbeAuswahlwert: "Anthrazit",
    bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
    pageName: "Zauneditor",
  };
  agt.arrangement.fromJSON(configuiration);
  // console.log(
  //   "pfosten 18 anker: ",
  //   agt.getPfosten().find((p) => p.id == 18)?.ankerAuswahlwert?.Key
  // );
  // APP.arrangement.segmente.forEach((s) => s.logit());
  // APP.debugit = true;
  // Debugs.watch(
  //   agt.getPfosten().find((p) => p.id == 18),
  //   "ankerAuswahlwert"
  // );
  // Debugs.watch(
  //   agt.getPfosten().find((p) => p.id == 18),
  //   "elemente"
  // );
  agt.update3d();
  // console.log("** NACH update3d");
  // console.log(
  //   "pfosten 18 anker: ",
  //   agt.getPfosten().find((p) => p.id == 18)?.ankerAuswahlwert?.Key
  // );
  // Der 1. Pfosten ist kein Eckpfosten mit mit id=168 (!)
  // Segment-ID konstant (17)
  // An mehreren Stellen (Eckadapter, Pfosten, UMProfil jeweils reset()) wird ecke.pfosten = null gesetzt
  // Werden Eckpfosten gecached und wiederverwendet?
  // Bug: pfosten.elemente ist nicht zugewiesen nach dem fromJSON
  // korrigiert, Fehler besteht weiter.
  // Bug: pfosten steht nahe der Ecke, aber die Ecke hat keinen Eckpfosten => folglich erzeugt sie einen neuen Pfosten
  // besser: pfosten an ensurePfosten übergeben
  // Bug: Eckpfosten landen nicht in der elementPfostenMap
  // nach dem fromJSON ist der Eckpfosten id 18 in segment.pfosten, und dem 1. Element als pfostenLinks zugewiesen
  // Der 1. Pfosten ist ein Eckpfosten mit id=18
  // zu Beginn von insertPfosten ist NICHT (der Eckpfosten id 18 in segment.pfosten) und NICHT (dem 1. Element als pfostenLinks zugewiesen)
  // => also muss die Verbindung Element zu Eckpfosten unterbrochen werden im vorherigen Update. Wo genau?
  // => schneideEckenUndSegmente, // Nach der Zuordnung: Bereinige Verweise und weise den Parent zu
  // if (p[key] != null && !partsAndPfosten.includes(p[key])) {
  //   p[key] = null;
  // }
  // partsAndPfosten sind vermutlich nur die des Segmentes, aber nicht der Eckpfosten!! => Eckpfosten hinzufügen
  // ok! Vor dem Update3D gilt jetzt parts[0].pfostenLinks == Eckpfosten
  // Aber im insertPfosten: this.parts[0].pfostenLinks==null
  // => Klappt!
  // Aber ursprünglicher Bug noch nicht gelöst!
  // Jetzt ist nachd em Update3d zwar der erste Pfosten id 18 => korrekt
  // trotzdem ist die Sturmanker-Option dort nicht gesetzt. Warum?
  // => watch id 18 sturmanker!
  // Ursache ist, dass in schneideEckenUndSegmente in // Erzeuge Eck-Objekte anhand der Eckpositionen
  // explizit ecke.pfosten.elemente = []; und ecke.reset()
  // APP.arrangement.segmente.forEach((s) => s.logit());

  // console.log(
  //   agt.ecken.map((e) => e.id),
  //   agt.segmente[0].getPfosten().map((s) => [s.id, s.ankerAuswahlwert?.Key]),
  //   agt.ecken.map((e) => e.pfosten).map((p) => [p?.id, p?.ankerAuswahlwert?.Key, p?.ecke?.id])
  // );
  assert.deepEquals(
    ["Individuell"],
    agt.segmente.map((s) => s.verteilungsstrategieAuswahlwert.Key)
  );
  assert.deepEquals(
    ["Sturmanker Anthrazit", undefined, undefined, "Sturmanker Anthrazit"],
    agt.segmente[0].getPfosten().map((s) => s.ankerAuswahlwert?.Key)
  );
  assert.deepEquals(
    [
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.915,0.033))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(0.075,1.800,0.050))",
      },
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.915,0.033))",
      },
      {
        type: "2937 SYSTEM RHOMBUS Bambus 180 x 180 cm",
        box: "((0.000,0.000,-0.010),(1.760,1.800,0.010))",
      },
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.915,0.033))",
      },
      {
        type: "2937 SYSTEM RHOMBUS Bambus 180 x 180 cm",
        box: "((0.000,0.000,-0.010),(1.800,1.800,0.010))",
      },
      {
        type: "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
        box: "((-0.036,-0.400,-0.033),(0.036,1.915,0.033))",
      },
      {
        type: "2937 SYSTEM RHOMBUS Bambus 180 x 180 cm",
        box: "((0.000,0.000,-0.010),(1.800,1.800,0.010))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(0.075,1.800,0.050))",
      },
    ],
    logPartBoxes([...agt.getPartsAndPfosten(), ...agt.getEmpties(), ...agt.aufbauten])
  );
};

export const testLoadRealConfiguration8: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  const configuiration = {
    inspiration: "Inspiration SYSTEM NEO WPC PLATINUM Lärche",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    grundriss: {
      strecken: [
        [
          {
            x: -13,
            y: -10,
          },
          {
            x: -4,
            y: -10,
          },
        ],
        [
          {
            x: -4,
            y: -10,
          },
          {
            x: -4,
            y: -6.08,
          },
        ],
        [
          {
            x: -4,
            y: -10,
          },
          {
            x: 2,
            y: -10,
          },
        ],
      ],
    },
    segmente: [
      {
        breite: 9,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.845,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 0.015,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 10,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 0,
            isStandardMass: true,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
          },
          {
            type: "Pfosten",
            x0: 1.775,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.6,
            höhe: 1.8,
            snap: -1,
            isBreiteKonfigurierbar: false,
            x0: 1.8375,
            füllungAuswahlwert: "Designgitter Trigon Weiß",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Designgitter_60x180",
            profilPosition: 2,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 1,
            isStandardMass: true,
            detailSerie: "SYSTEM Designgitter",
            anMauer: "AnMauer_nein",
            isMasselement: false,
          },
          {
            position: {
              x: 2.445,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0.008483948707580735,
                z: -0.017502999864518642,
              },
              max: {
                x: 0.015,
                y: 1.9400000000000002,
                z: 0.017502999864518642,
              },
            },
            size: {
              x: 0.03,
              y: 1.9315160512924194,
              z: 0.035005999729037285,
            },
            type: "UMProfil",
            meta: "2415 SYSTEM U-Montageprofil 192 anthrazit",
          },
          {
            type: "Pfosten",
            x0: 2.46,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwert: "Elementhalter Weiß",
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Metallpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
            pfostenAuswahlwert: "Torpfosten Aufschrauben Weiß",
          },
          {
            type: "Element",
            breite: 0.98,
            höhe: 1.8,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 2.5525,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_weiß",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            rahmenAuswahlwert: "Tor_Rahmen_Weiss",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Einzeltor",
            massAuswahlwert: "Einzeltor_Easy",
            profilPosition: 2,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: true,
            elementNr: 2,
            isStandardMass: true,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasstor: true,
            isMasselement: false,
            isMassProfil: false,
            isEAntrieb: false,
            key: "2966 SYSTEM NEO WPC Platinum Standardtor einseitig_15",
            lichteWeite: 1.005,
            einsteckschlossAuswahlwert: "Einsteckschloss_inklusive",
            beschlagsatzAuswahlwert: "Beschlagsatz_inklusive",
            hideRahmen: false,
            bestelllisteArtikel: ["1272", "609", "4652", "2550"],
            füllungName: "Füllung",
            pdf: [],
          },
          {
            type: "Pfosten",
            x0: 3.545,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwert: "Elementhalter Weiß",
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Metallpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
            pfostenAuswahlwert: "Torpfosten Aufschrauben Weiß",
          },
          {
            position: {
              x: 3.6400000000000006,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0.008483948707580735,
                z: -0.017502999864518642,
              },
              max: {
                x: 0.015,
                y: 1.9400000000000002,
                z: 0.017502999864518642,
              },
            },
            size: {
              x: 0.03,
              y: 1.9315160512924194,
              z: 0.035005999729037285,
            },
            type: "UMProfil",
            meta: "2415 SYSTEM U-Montageprofil 192 anthrazit",
          },
          {
            type: "Element",
            breite: 0.6,
            höhe: 1.8,
            snap: -1,
            isBreiteKonfigurierbar: false,
            x0: 3.6475,
            füllungAuswahlwert: "Designgitter Trigon Weiß",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Designgitter_60x180",
            profilPosition: 2,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 3,
            isStandardMass: true,
            detailSerie: "SYSTEM Designgitter",
            anMauer: "AnMauer_nein",
            isMasselement: false,
          },
          {
            type: "Pfosten",
            x0: 4.24,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.555,
            höhe: 1.845,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 4.29,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 10,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 4,
            isStandardMass: false,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
          },
          {
            type: "Pfosten",
            x0: 5.825,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
      {
        breite: 3.92,
        partsAndPfosten: [
          {
            type: "Pfosten",
            x0: 0.135,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.2,
            höhe: 0.945,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.185,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x90_Easy",
            profilPosition: 4,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 5,
            isStandardMass: false,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
          },
          {
            type: "Pfosten",
            x0: 1.365,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.6,
            höhe: 0.9,
            snap: 1,
            isBreiteKonfigurierbar: false,
            x0: 1.435,
            füllungAuswahlwert: "Designgitter Trigon Weiß",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Designgitter_60x90",
            profilPosition: 2,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 6,
            isStandardMass: true,
            detailSerie: "SYSTEM Designgitter",
            anMauer: "AnMauer_nein",
            isMasselement: false,
          },
          {
            type: "Pfosten",
            x0: 2.035,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.91,
            höhe: 1.84,
            snap: 1,
            isBreiteKonfigurierbar: false,
            x0: 2.085,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Anschluss",
            massAuswahlwert: "Anschluss_Easy",
            profilPosition: 2,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: true,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 7,
            isStandardMass: true,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
          },
          {
            type: "Pfosten",
            x0: 2.975,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.85,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 3.025,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "90x180_Easy",
            profilPosition: 10,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 8,
            isStandardMass: false,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
          },
          {
            position: {
              x: 3.8699999999999997,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0,
                z: -0.017502999864518642,
              },
              max: {
                x: 0.015,
                y: 1.93,
                z: 0.017502999864518642,
              },
            },
            size: {
              x: 0.03,
              y: 1.93,
              z: 0.035005999729037285,
            },
            type: "UMProfil",
            meta: "2415 SYSTEM U-Montageprofil 192 anthrazit",
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
      {
        breite: 6,
        partsAndPfosten: [
          {
            type: "Pfosten",
            x0: 0.535,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.585,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Trigon Weiss/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_weiss",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 10,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 9,
            isStandardMass: true,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
          },
          {
            type: "Pfosten",
            x0: 2.345,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 2.395,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Trigon Weiss/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_weiss",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 10,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 10,
            isStandardMass: true,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
          },
          {
            type: "Pfosten",
            x0: 4.155,
            pfostenfarbeAuswahlwert: "Weiß",
            pfostenfarbeAuswahlwertIndividualisert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisert: false,
            elementhalterAuswahlwertIndividualisert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 4.205,
            füllungAuswahlwert: "SYSTEM NEO WPC PLATINUM Lärche",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Trigon Weiss/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_weiss",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 10,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 11,
            isStandardMass: true,
            detailSerie: "SYSTEM NEO WPC PLATINUM",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
    ],
    ecken: [
      {
        position: {
          x: -4,
          y: 0,
          z: -10,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: -4,
            y: 0,
            z: -10,
          },
          pfostenfarbeAuswahlwert: "Weiß",
          pfostenfarbeAuswahlwertIndividualisert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisert: false,
          elementhalterAuswahlwertIndividualisert: false,
          pfostenartAuswahlwert: "Steckpfosten",
          montageadapterAuswahlwert: "Montageadapter_ohne",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: -13,
          y: 0,
          z: -10,
        },
      },
      {
        position: {
          x: -4,
          y: 0,
          z: -6.08,
        },
      },
      {
        position: {
          x: 2,
          y: 0,
          z: -10,
        },
      },
    ],
    aufbauten: [],
    lichtleistenSplitter: 0,
    pfostenartAuswahlwert: "Steckpfosten",
    pfostenfarbeAuswahlwert: "Weiß",
    bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
    elementhalterAuswahlwert: "2096 Elementhalter",
    verteilungsstrategieAuswahlwert: "LeerraumLinks",
    verbundankerAuswahlwert: "Verbundanker-Set_mit",
    pageName: "Zauneditor",
  };
  agt.arrangement.fromJSON(configuiration);
  agt.update3d();
  assert.deepEquals(
    [
      {
        type: "4831 SYSTEM Steckpfosten Weiss z. Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.940,0.033))",
      },
      {
        type: "3730 SYSTEM NEO WPC PLATINUM Zaunfeld-Set Lärche 178 x 184 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.845,0.010))",
      },
      {
        type: "4831 SYSTEM Steckpfosten Weiss z. Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.940,0.033))",
      },
      {
        type: "3755 SYSTEM Designgitter Trigon Weiß 60 x 180 cm",
        box: "((0.000,0.000,-0.010),(0.605,1.800,0.010))",
      },
      {
        type: "4606 SYSTEM  U-Klemmprofil Weiß 192 cm",
        box: "((-0.015,0.008,-0.020),(0.015,1.940,0.020))",
      },
      {
        type: "E1292 Torpfosten aufschrauben 180 weiß Schlossseite",
        box: "((-0.040,0.010,-0.040),(0.040,1.950,0.040))",
      },
      {
        type: "2966 SYSTEM NEO WPC Platinum Sondertor einseitig_15",
        box: "((0.000,0.000,-0.025),(0.980,1.800,0.025))",
      },
      {
        type: "E1291 Torpfosten aufschrauben 180 weiß Aufhängeseite",
        box: "((-0.040,0.010,-0.040),(0.040,1.950,0.040))",
      },
      {
        type: "4606 SYSTEM  U-Klemmprofil Weiß 192 cm",
        box: "((-0.015,0.008,-0.020),(0.015,1.940,0.020))",
      },
      {
        type: "3755 SYSTEM Designgitter Trigon Weiß 60 x 180 cm",
        box: "((0.000,0.000,-0.010),(0.605,1.800,0.010))",
      },
      {
        type: "4831 SYSTEM Steckpfosten Weiss z. Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.940,0.033))",
      },
      {
        type: "3730 SYSTEM NEO WPC PLATINUM Zaunfeld-Set Lärche 178 x 184 cm",
        box: "((0.000,0.000,-0.010),(1.555,1.845,0.010))",
      },
      {
        type: "4831 SYSTEM Steckpfosten Weiss z. Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.940,0.033))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(3.105,1.800,0.050))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(0.150,1.800,0.050))",
      },
      {
        type: "4830 SYSTEM Steckpfosten Weiss z. Aufschrauben 105 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.060,0.033))",
      },
      {
        type: "3730 SYSTEM NEO WPC PLATINUM Zaunfeld-Set Lärche 178 x 184 cm",
        box: "((0.000,0.000,-0.010),(1.200,0.945,0.010))",
      },
      {
        type: "4830 SYSTEM Steckpfosten Weiss z. Aufschrauben 105 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.060,0.033))",
      },
      {
        type: "3757 SYSTEM Designgitter Trigon Weiß 60 x 90 cm",
        box: "((0.000,0.000,-0.010),(0.605,0.900,0.010))",
      },
      {
        type: "4830 SYSTEM Steckpfosten Weiss z. Aufschrauben 105 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.055,0.033))",
      },
      {
        type: "3731 SYSTEM NEO WPC PLATINUM Zaun-Anschluss-Set Lärche 91 x 184 auf 94 cm",
        box: "((0.000,0.000,-0.010),(0.910,1.840,0.010))",
      },
      {
        type: "4831 SYSTEM Steckpfosten Weiss z. Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.940,0.033))",
      },
      {
        type: "3730 SYSTEM NEO WPC PLATINUM Zaunfeld-Set Lärche 178 x 184 cm",
        box: "((0.000,0.000,-0.010),(0.850,1.845,0.010))",
      },
      {
        type: "4606 SYSTEM  U-Klemmprofil Weiß 192 cm",
        box: "((-0.015,0.000,-0.020),(0.015,1.930,0.020))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(0.535,1.800,0.050))",
      },
      {
        type: "4831 SYSTEM Steckpfosten Weiss z. Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.940,0.033))",
      },
      {
        type: "3730 SYSTEM NEO WPC PLATINUM Zaunfeld-Set Lärche 178 x 184 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.845,0.010))",
      },
      {
        type: "4831 SYSTEM Steckpfosten Weiss z. Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.940,0.033))",
      },
      {
        type: "3730 SYSTEM NEO WPC PLATINUM Zaunfeld-Set Lärche 178 x 184 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.845,0.010))",
      },
      {
        type: "4831 SYSTEM Steckpfosten Weiss z. Aufschrauben 192 cm",
        box: "((-0.036,0.010,-0.033),(0.036,1.940,0.033))",
      },
      {
        type: "3730 SYSTEM NEO WPC PLATINUM Zaunfeld-Set Lärche 178 x 184 cm",
        box: "((0.000,0.000,-0.010),(1.780,1.845,0.010))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(3.105,1.800,0.050))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(0.150,1.800,0.050))",
      },
      {
        type: "Empty",
        box: "((0.000,0.000,-0.050),(0.535,1.800,0.050))",
      },
    ],
    logPartBoxes([...agt.getPartsAndPfosten(), ...agt.getEmpties(), ...agt.aufbauten])
  );
};

export const testLoadRealConfiguration9: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  const configuiration = {
    inspiration: "Inspiration SYSTEM WPC CLASSIC Sand",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    grundriss: {
      ecken: [
        {
          id: 4,
          punkt: {
            x: -8.775,
            y: 0,
          },
        },
        {
          id: 5,
          punkt: {
            x: -7.225,
            y: 0,
          },
        },
        {
          id: 448,
          punkt: {
            x: -6.995117759994212,
            y: -1.5081273079464395,
          },
        },
        {
          id: 1141,
          punkt: {
            x: 0.15941497649342473,
            y: -1.2283750558969935,
          },
        },
        {
          id: 2451,
          punkt: {
            x: -0.2451598444966793,
            y: -28.56538146139467,
          },
        },
        {
          id: 13109,
          punkt: {
            x: -1.954560253335589,
            y: -29.584228968267688,
          },
        },
        {
          id: 14504,
          punkt: {
            x: -17.0694867451183,
            y: -29.975888447924703,
          },
        },
      ],
      kanten: [
        {
          ecken: [4, 5],
        },
        {
          ecken: [5, 448],
        },
        {
          ecken: [448, 1141],
        },
        {
          ecken: [1141, 2451],
        },
        {
          ecken: [2451, 13109],
        },
        {
          ecken: [13109, 14504],
        },
      ],
    },
    segmente: [
      {
        breite: 1.5478,
        partsAndPfosten: [
          {
            type: "Pfosten",
            x0: 0,
            pfostenfarbeAuswahlwert: "Anthrazit",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.5228,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.01,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 0,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_links",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
        ],
        verteilungsstrategieAuswahlwert: "StandardRechts",
      },
      {
        breite: 1.5255,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.4955,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.015,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 1,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
        ],
        verteilungsstrategieAuswahlwert: "StandardRechts",
      },
      {
        breite: 7.16,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 0.9692,
            höhe: 1.545,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 0.015,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "120x180_Easy",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 2,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 0.9642,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 1.0142,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 3,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 2.7742,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 2.8242,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 4,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            position: {
              x: 4.5992073468509105,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0,
                z: -0.017502999864518642,
              },
              max: {
                x: 0.015,
                y: 1.6900000000000002,
                z: 0.017502999864518642,
              },
            },
            size: {
              x: 0.03,
              y: 1.6900000000000002,
              z: 0.035005999729037285,
            },
            type: "UMProfil",
            meta: "2415 SYSTEM U-Montageprofil 192 anthrazit",
          },
          {
            type: "Pfosten",
            x0: 4.6142,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwert: "Elementhalter Weiß",
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Metalltorpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
            pfostenAuswahlwert: "Torpfosten Einbetonieren Anthrazit",
          },
          {
            type: "Element",
            breite: 1.2,
            höhe: 1.55,
            snap: 0,
            isBreiteKonfigurierbar: true,
            x0: 4.7067,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            rahmenAuswahlwert: "Tor_Rahmen_Anthrazit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_Tore",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Einzeltor",
            massAuswahlwert: "Einzeltor_Easy",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: true,
            elementNr: 5,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasstor: true,
            isMasselement: false,
            isMassProfil: false,
            isEAntrieb: false,
            key: "2499 SYSTEM WPC Classic Mass Einzeltor zweiseitig_15",
            lichteWeite: 1.225,
            einsteckschlossAuswahlwert: "Einsteckschloss_inklusive",
            beschlagsatzAuswahlwert: "Beschlagsatz_inklusive",
            hideRahmen: false,
            showProfilausrichtung: true,
            showAdapterleiste: true,
            hasAnschlagprofil: false,
            bestelllisteArtikel: ["2499", "2623_anthrazit", "1251", "2550"],
            ArtikelID: "2499_wpc_classic_xl",
            füllungName: "Füllung",
            pdf: [],
            elementID: 0,
            showFüllungsseite: true,
            showDetailBild: true,
          },
          {
            type: "Pfosten",
            x0: 5.9192,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwert: "Elementhalter Weiß",
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Metalltorpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
            pfostenAuswahlwert: "Torpfosten Einbetonieren Anthrazit",
          },
          {
            position: {
              x: 6.01420734685091,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0,
                z: -0.02000000001862645,
              },
              max: {
                x: 0.015,
                y: 1.6900000000000002,
                z: 0.02000000001862645,
              },
            },
            size: {
              x: 0.03,
              y: 1.6900000000000002,
              z: 0.0400000000372529,
            },
            type: "UMProfil",
            meta: "2777 SYSTEM U-Klemmprofil Anthrazit 192 cm",
          },
          {
            type: "Element",
            breite: 1.0893,
            höhe: 1.545,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 6.0092,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "120x180_Easy",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 6,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            position: {
              x: 7.093502514569495,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0,
                z: -0.017502999864518642,
              },
              max: {
                x: 0.015,
                y: 1.595,
                z: 0.017502999864518642,
              },
            },
            size: {
              x: 0.03,
              y: 1.595,
              z: 0.035005999729037285,
            },
            type: "UMProfil",
            meta: "2415 SYSTEM U-Montageprofil 192 anthrazit",
          },
          {
            position: {
              x: 7.116493999914081,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.008206000085920099,
                y: 0,
                z: -0.015768498182296753,
              },
              max: {
                x: 0.008206000085920099,
                y: 1.595,
                z: 0.015768498182296753,
              },
            },
            size: {
              x: 0.016412000171840198,
              y: 1.595,
              z: 0.031536996364593506,
            },
            type: "Eckadapter",
            meta: "Eckadapter 135 oder 45 Anthrazit 192 cm",
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
      {
        breite: 27.34,
        partsAndPfosten: [
          {
            position: {
              x: 0.04350600008592011,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 0,
              x: 0,
              y: 1,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.008206000085920099,
                y: 0,
                z: -0.015768498182296753,
              },
              max: {
                x: 0.008206000085920099,
                y: 1.595,
                z: 0.015768498182296753,
              },
            },
            size: {
              x: 0.016412000171840198,
              y: 1.595,
              z: 0.031536996364593506,
            },
            type: "Eckadapter",
            meta: "Eckadapter 135 oder 45 Anthrazit 192 cm",
          },
          {
            position: {
              x: 0.0667120001718402,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0,
                z: -0.017502999864518642,
              },
              max: {
                x: 0.015,
                y: 1.595,
                z: 0.017502999864518642,
              },
            },
            size: {
              x: 0.03,
              y: 1.595,
              z: 0.035005999729037285,
            },
            type: "UMProfil",
            meta: "2415 SYSTEM U-Montageprofil 192 anthrazit",
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.0615,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 7,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 1.8215,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 1.8715,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 8,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 3.6315,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 3.6815,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 9,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 5.4415,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 5.4915,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 10,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 7.2515,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 7.3015,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 11,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 9.0615,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 9.1115,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 12,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 10.8715,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 10.9215,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 13,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 12.6815,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 12.7315,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 14,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 14.4915,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 14.5415,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 15,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 16.3015,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 16.3515,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 16,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 18.1115,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 18.1615,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 17,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 19.9215,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 19.9715,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 18,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 21.7315,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 21.7815,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 19,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 23.5415,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 23.5915,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 20,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 25.3515,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.9468,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 25.4015,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "120x180_Easy",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 21,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 26.3282,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.9468,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 26.3782,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "120x180_Easy",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 22,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
        ],
        verteilungsstrategieAuswahlwert: "StandardRechts",
      },
      {
        breite: 1.99,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1,
            höhe: 1.545,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 0.015,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "120x180_Easy",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 23,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 0.995,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.93,
            höhe: 1.545,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 1.045,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "120x180_Easy",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 24,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
      {
        breite: 15.12,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.015,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 25,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 1.775,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 1.825,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 26,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 3.585,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 3.635,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 27,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 5.395,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 5.445,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 28,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 7.205,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 7.255,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 29,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 9.015,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 9.065,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 30,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 10.825,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 10.875,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 31,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 12.635,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 12.685,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "Longlife_Romo_180x180_Rechteck",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 32,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 14.445,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.61,
            höhe: 1.545,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 14.495,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "90x180_Easy",
            profilPosition: 9,
            profilPositionIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 33,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            elementID: 0,
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
    ],
    ecken: [
      {
        position: {
          x: -8.77282827790981,
          y: 0,
          z: 0,
        },
      },
      {
        position: {
          x: -7.225,
          y: 0,
          z: 0,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: -7.225,
            y: 0,
            z: 0,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Steckpfosten",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: -6.995117759994212,
          y: 0,
          z: -1.5081273079464395,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: -6.995117759994212,
            y: 0,
            z: -1.5081273079464395,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Steckpfosten",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: 0.15941497649342473,
          y: 0,
          z: -1.2283750558969935,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: 0.15941497649342473,
            y: 0,
            z: -1.2283750558969935,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwert: "Elementhalter Weiß",
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Metalltorpfosten",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: -0.2451598444966793,
          y: 0,
          z: -28.56538146139467,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: -0.2451598444966793,
            y: 0,
            z: -28.56538146139467,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Steckpfosten",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: -1.954560253335589,
          y: 0,
          z: -29.584228968267688,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: -1.954560253335589,
            y: 0,
            z: -29.584228968267688,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Steckpfosten",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: -17.0694867451183,
          y: 0,
          z: -29.975888447924703,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: -17.0694867451183,
            y: 0,
            z: -29.975888447924703,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Steckpfosten",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
    ],
    aufbauten: [
      {
        Key: "khzh66iyiod5",
        aufbauMeta: "Haus",
        position: {
          x: -12.77282827790981,
          y: 0,
          z: -2.9979871444610637,
        },
        size: {
          x: 8,
          y: 4,
          z: 6,
        },
        drehung: 0,
      },
    ],
    lichtleistenSplitter: 0,
    pfostenartAuswahlwert: "Steckpfosten",
    pfostenfarbeAuswahlwert: "Anthrazit",
    bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
    elementhalterAuswahlwert: "2096 Elementhalter",
    verteilungsstrategieAuswahlwert: "StandardRechts",
    bestellliste: [
      {
        ArtikelID: "2175",
        Anzahl: 27,
        AnzahlEditiert: false,
        JacoIds: [
          0, 1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 31, 32, 33,
        ],
      },
      {
        ArtikelID: "2272",
        Anzahl: 6,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "2273",
        Anzahl: 6,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "1590",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "2145",
        Anzahl: 27,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "2140",
        Anzahl: 4,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "2499_wpc_classic_xl",
        Anzahl: 1,
        AnzahlEditiert: false,
        Mass: "120 x 155 cm",
        JacoIds: [5],
      },
      {
        ArtikelID: "2623_anthrazit",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [5],
      },
      {
        ArtikelID: "1251",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [5],
      },
      {
        ArtikelID: "2550",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [5],
      },
      {
        ArtikelID: "2415",
        Anzahl: 4,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "2777",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "2873",
        Anzahl: 2,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "1398",
        Anzahl: 4,
        AnzahlEditiert: false,
        JacoIds: [],
      },
    ],
    customAnzahlen: {
      "1398": 4,
    },
    gesamtpreis: 11195.45,
    baugruppen: [
      [
        {
          ArtikelID: "2175",
          Anzahl: 33,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2145",
          Anzahl: 27,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "1398",
          Anzahl: 3,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "1590",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2140",
          Anzahl: 4,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "1398",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2499_wpc_classic_xl",
          Anzahl: 1,
          MassOrBauseitsTag: "120 x 155 cm",
        },
        {
          ArtikelID: "2623_anthrazit",
          Anzahl: 1,
          MassOrBauseitsTag: "120 x 155 cm",
        },
        {
          ArtikelID: "1251",
          Anzahl: 1,
          MassOrBauseitsTag: "120 x 155 cm",
        },
        {
          ArtikelID: "2550",
          Anzahl: 1,
          MassOrBauseitsTag: "120 x 155 cm",
        },
      ],
      [
        {
          ArtikelID: "2415",
          Anzahl: 1,
          MassOrBauseitsTag: null,
        },
      ],
    ],
    warnungen: [],
    montageanleitungenArtikelIDs: ["2145", "2499"],
    inspirationsBilder: ["/Artikel/system-wpc-classic-sand.jpg"],
    pageName: "Zauneditor",
    userDefinedArticles: [],
    hinweistexte: ["Füllungsseite_B", "WORKFLOW_Einzeltor"],
    zauneditorVisited: true,
  };
  agt.arrangement.fromJSON(configuiration);
  agt.update3d();
  assert.equals(1, agt.getTore().length, "Anzahl Tore");
  assert.equals(0, agt.getElemente().filter((e) => e.höhe > 1.8).length, "Anzahl hohe Elemente");
  assertWarnungen(agt, []);
};
